"use client"

import type React from "react"
import { Container, Row, Col } from "reactstrap"
import TicketPurchaseForm from "./TicketPurchaseForm"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"

const TicketPurchaseContainer: React.FC = () => {
  return (
    <>
      <style>{`
        .ticket-purchase-container {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          min-height: 100vh;
          padding: 2rem 0;
        }
        
        .header-section {
          text-align: center;
          margin-bottom: 3rem;
        }
        
        .header-title {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 1rem;
        }
        
        .header-subtitle {
          color: #6c757d;
          font-size: 1.1rem;
          max-width: 600px;
          margin: 0 auto;
        }
        
        .help-info {
          background: #e3f2fd;
          border: 1px solid #bbdefb;
          border-radius: 0.75rem;
          padding: 1.5rem;
          margin-bottom: 2rem;
        }
      `}</style>

      {/* <div className="ticket-purchase-container"> */}
        <Breadcrumbs mainTitle="Purchase Ticket" parent="Purchase Ticket" />
        <Container fluid>
          {/* Header Section */}
          <div className="header-section">
            <h1 className="header-title">
              <i className="fa fa-ticket me-3"></i>
              Customer Ticket Assistance
            </h1>
           
          </div>

         

          {/* Main Content */}
          <Row className="justify-content-center">
            <Col lg="12" xl="8">
              <TicketPurchaseForm />
            </Col>
          </Row>
        </Container>
      {/* </div> */}
    </>
  )
}

export default TicketPurchaseContainer
